
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': '常规',
	'widgetId': '窗口小部件标识',
	'widgetType': '窗口小部件类型',
	'serviceability': '可维护性',
	'copyButton': '复制',
	'closeButton': '关闭',
	'specification': '规范',
	'viewSpecification': '查看规范'
});
